import * as Yup from "yup";
export const initialValues = (data) => {
  console.log(data);
  return {
    ...data,
    englishCardName: data?.localized_data?.en?.name,
    arabicCardName: data?.localized_data?.ar?.name,
    priceAfterDiscount: data?.price_after_discount,
  };
};
export const structure = (supportedLang, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "image",
        label: t ? `${t("gift_cards.wrap_photo")}*` : "Wrap Photo*",
        placeholder: "test",
        text: t
          ? t("vendors.text_upload_photo_desc")
          : "file size no more than",
        width: "35%",
      },
      { width: "47%" },
      {
        name: `englishCardName`,
        kind: "input",
        type: "text",
        label: t ? `${t("gift_cards.card_name")}(EN)*` : "Card Name(EN)*",
        width: "47%",
        placeholder: t
          ? t("gift_cards.enter_english_card_name")
          : "Enter the english card name",
      },
      {
        name: `arabicCardName`,
        kind: "input",
        type: "text",
        label: t ? `${t("gift_cards.card_name")}(AR)*` : "Card Name(AR)*",
        width: "47%",
        placeholder: t
          ? t("gift_cards.enter_arabic_card_name")
          : "Enter the arabic card name",
      },
      {
        name: `price`,
        kind: "input",
        type: "text",
        label: t ? t("gift_cards.price") : "Price",
        width: "47%",
        placeholder: t ? t("gift_cards.enter_price") : "Enter the price",
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>,
      },
      {
        name: `priceAfterDiscount`,
        kind: "input",
        type: "text",
        label: t
          ? t("gift_cards.price_after_discount")
          : "Price after discount",
        width: "47%",
        placeholder: t
          ? t("gift_cards.enter_price_after_discount")
          : "Enter the price after discount",
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>,
      },
    ],
  },
];

export const validationSchema = (t) =>
  Yup.object({
    image: Yup.string().required(t ? t("vendors.error_required") : "required"),
    englishCardName: Yup.string().required(
      t ? t("vendors.error_required") : "required",
    ),
    arabicCardName: Yup.string().required(
      t ? t("vendors.error_required") : "required",
    ),
    price: Yup.number(t ? t("products.error_invalid_price") : "Invalid Price"),
    priceAfterDiscount: Yup.number(
      t ? t("products.error_invalid_price") : "Invalid Price",
    ),
  });
